<template>
  <v-card class="bordered-card" :id="id">
    <video
        style="border-radius: 15px!important; height: 97%"
        width="100%"
        :ref="reff"
        muted
        playsinline
        autoplay
    />
    <div class="under-video-layer-self">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn type="button" fab x-small :color="colors.success"
                 v-bind="attrs" v-on="on" class="white--text"
                 @click="$emit('toggleFullScreen', id)">
            <v-icon>mdi-fullscreen</v-icon>
          </v-btn>
        </template>
        <span>تمام صفحه</span>
      </v-tooltip>

      <v-tooltip v-if="microphonePermission" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn type="button" fab x-small :color="colors.success"
                 v-bind="attrs" v-on="on" class="white--text mr-1" @click="$emit('toggleMuteAudio')">
            <v-icon>{{ mutedAudio ? "mdi-microphone-off" : "mdi-microphone" }}</v-icon>
          </v-btn>
        </template>
        <span>{{ mutedAudio ? "وصل کردن میکروفن" : "قطع کردن میکروفن" }}</span>
      </v-tooltip>

      <v-tooltip v-if="webcamPermission" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn type="button" fab x-small :color="colors.success"
                 v-bind="attrs" v-on="on" class="white--text mr-1" @click="$emit('toggleMuteVideo')">
            <v-icon>{{ mutedVideo ? "mdi-webcam-off" : "mdi-webcam" }}</v-icon>
          </v-btn>
        </template>
        <span>{{ mutedVideo ? "وصل کردن وب کم" : "قطع کردن وب کم" }}</span>
      </v-tooltip>

      <v-tooltip v-if="screenPermission" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn type="button" fab x-small :color="colors.success"
                 v-bind="attrs" v-on="on" class="white--text mr-1" @click="$emit('toggleShareScreen')">
            <v-icon>{{ screenIsSharing ? "mdi-projector-screen" : "mdi-projector-off" }}</v-icon>
          </v-btn>
        </template>
        <span>{{ screenIsSharing ? "قطع کردن صفحه نمایش" : "اشتراک گذاری صفحه نمایش" }}</span>
      </v-tooltip>

      <v-tooltip v-if="whiteboardPermission" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn type="button" fab x-small :color="colors.success"
                 v-bind="attrs" v-on="on" class="white--text mr-1" @click="$emit('toggleWhiteBoard')">
            <v-icon>{{ whiteBoardStatus ? "mdi-brush" : "mdi-brush-off" }}</v-icon>
          </v-btn>
        </template>
        <span>{{ whiteBoardStatus ? "بستن وایت برد" : "باز کردن وایت برد" }}</span>
      </v-tooltip>

      <v-tooltip v-if="videoPermission" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn :disabled="videoFileIsSharing" type="button" fab x-small
                 v-bind="attrs" v-on="on" :color="colors.success" class="white--text mr-1"
                 @click="$emit('selectVideo')">
            <v-icon>mdi-file-video</v-icon>
          </v-btn>
          <input @change="$emit('videoFileSelected')" type="file" id="video-file-input" style="display: none"
                 accept="video/*">
        </template>
        <span>اشتراک گذاری فایل ویدیویی</span>
      </v-tooltip>

      <v-tooltip v-if="audioPermission" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn :disabled="audioFileIsSharing" type="button" fab x-small
                 v-bind="attrs" v-on="on" :color="colors.success" class="white--text mr-1"
                 @click="$emit('selectAudio')">
            <v-icon>mdi-file-music</v-icon>
          </v-btn>
          <input @change="$emit('audioFileSelected')" type="file" id="audio-file-input" style="display: none"
                 accept="audio/*">
        </template>
        <span>اشتراک گذاری فایل صوتی</span>
      </v-tooltip>

      <v-tooltip v-if="recordPermission" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" type="button" fab x-small :color="colors.success"
                 class="white--text mr-1" @click="$emit('toggleRecord')">
            <v-icon v-if="!isRecording">mdi-record-rec</v-icon>
            <v-icon v-else-if="recordIcon === 1">mdi-record</v-icon>
            <v-icon v-else-if="recordIcon === 2">mdi-record-circle</v-icon>
          </v-btn>
        </template>
        <span>{{ isRecording ? 'در حال ضبط... برای توقف کلیک کنید' : 'ضبط کلاس'}}</span>
      </v-tooltip>


      <v-chip small class="current-user-chip" :color="colors.danger">
        {{ currentUser.name }}
      </v-chip>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MeetingSelfCard",
  props: [
    'id',
    'reff',
    'colors',
    'mutedAudio',
    'mutedVideo',
    'screenIsSharing',
    'microphonePermission',
    'webcamPermission',
    'screenPermission',
    'whiteboardPermission',
    'whiteBoardStatus',
    'videoPermission',
    'videoFileIsSharing',
    'audioPermission',
    'audioFileIsSharing',
    'recordPermission',
    'isRecording',
    'recordIcon',
    'currentUser',
  ]
}
</script>

<style scoped>
.bordered-card {
  border: 1px solid black;
  border-radius: 15px !important;
  padding: 10px 10px 40px;
  height: 100%;
}

.current-user-chip {
  float: left;
  margin-top: 4px;
  color: white
}

.under-video-layer-self {
  height: 40px;
  bottom: 0;
  position: absolute;
  padding: 0 10px;
  width: 100%;
  right: 0;
  left: 0;
  text-align: right !important;
}

video {
  transform: rotateY(180deg);
  -webkit-transform:rotateY(180deg); /* Safari and Chrome */
  -moz-transform:rotateY(180deg); /* Firefox */
}
</style>